(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[9610],{

/***/ 58262:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ wrapper; }
});

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9008);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(94184);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./src/components/layout/index.tsx + 6 modules
var layout = __webpack_require__(16569);
// EXTERNAL MODULE: ./src/components/product/relevance/wrapper/index.module.scss
var index_module = __webpack_require__(89262);
var index_module_default = /*#__PURE__*/__webpack_require__.n(index_module);
// EXTERNAL MODULE: ./src/components/tdk/index.tsx + 1 modules
var tdk = __webpack_require__(6071);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./src/components/product/relevance/nav/index.module.scss
var nav_index_module = __webpack_require__(73649);
var nav_index_module_default = /*#__PURE__*/__webpack_require__.n(nav_index_module);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./src/constants/index.ts
var constants = __webpack_require__(40238);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./src/components/product/relevance/nav/index.tsx
/* eslint-disable react-hooks/exhaustive-deps */








var timer;

var Nav = function Nav(_ref) {
  var defaultIndex = _ref.defaultIndex,
      menu = _ref.menu,
      _ref$type = _ref.type,
      type = _ref$type === void 0 ? 1 : _ref$type;

  var _useState = (0,react.useState)(defaultIndex || 0),
      current = _useState[0],
      setCurrent = _useState[1];

  var _useState2 = (0,react.useState)(false),
      sticky = _useState2[0],
      setSticky = _useState2[1];

  var _useState3 = (0,react.useState)(false),
      once = _useState3[0],
      setOnce = _useState3[1]; //首次动画执行


  var count = (0,react.useRef)(0); // 首次动画执行占位不需要过渡效果 0初始状态 1 首次动画执行（自动滚动），其余为手动滚动

  var dom = (0,react.useRef)(null);
  var subNav = (0,react.useRef)();
  var menuRef = (0,react.useRef)(null);
  var router = (0,next_router.useRouter)();
  var onScroll = (0,react.useCallback)(function () {
    var scrollTop = document.documentElement.scrollTop;

    if (scrollTop > 100) {
      count.current++;
      setSticky(true);
      setOnce(false);
      count.current++;
    } else {
      if (count.current >= 1) {
        count.current = 2;
      }

      setSticky(false);
    }
  }, []);
  (0,react.useEffect)(function () {
    window.addEventListener('scroll', onScroll);
    return function () {
      window.removeEventListener('scroll', onScroll);
    };
  }, [onScroll]);
  (0,react.useEffect)(function () {
    if (window.innerWidth > 768) {
      setOnce(true);
      requestAnimation();
    }
  }, []);

  var requestAnimation = function requestAnimation() {
    var scrollTop = document.documentElement.scrollTop;
    var speed = scrollTop > 80 ? 1 : 2;
    timer = window.requestAnimationFrame(function () {
      if (scrollTop > 100) {
        cancelAnimationFrame(timer);
      } else {
        document.documentElement.scrollTop = scrollTop + speed;
        requestAnimation();
      }
    });
  }; // 移动端-设置当前页面导航按钮是否在可视口完全显示


  (0,react.useEffect)(function () {
    var _menuRef$current;

    var childNodes = (_menuRef$current = menuRef.current) === null || _menuRef$current === void 0 ? void 0 : _menuRef$current.childNodes;

    if (childNodes && window.innerWidth < 768) {
      var child = childNodes[current];
      var position = child.getClientRects();
      var _position$ = position[0],
          left = _position$.left,
          width = _position$.width;
      var diff = left + width - window.innerWidth;

      if (diff > 0) {
        if (menuRef.current) {
          var distance = menuRef.current.scrollLeft + diff + 10;
          menuRef.current.scrollLeft = distance;
        }
      }
    }
  }, []);

  var Goto = function Goto(index, url) {
    setCurrent(index);
    router.push(url); // window.location.href = url;
  };

  return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      ref: dom,
      className: classnames_default()((nav_index_module_default()).nav__theme_parent, once && (nav_index_module_default()).once, sticky && (nav_index_module_default()).sticky),
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: classnames_default()((nav_index_module_default()).logo, sticky && (nav_index_module_default()).show, !sticky && (nav_index_module_default()).hide),
        children: /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
          href: constants/* homeUrl */.hB,
          children: /*#__PURE__*/(0,jsx_runtime.jsx)((image_default()), {
            src: "/v2/images/login-logo.png",
            alt: "logo",
            width: "134",
            height: "27"
          })
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: classnames_default()((nav_index_module_default())["nav-pc"]),
        ref: subNav,
        children: menu.map(function (item, index) {
          return /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            onClick: function onClick() {
              return Goto(index, item.link);
            },
            className: classnames_default()((nav_index_module_default())["nav-pc-item"], index === current && (nav_index_module_default()).focus),
            children: item.name
          }, item.name);
        })
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: classnames_default()((nav_index_module_default()).transition, count.current === 1 && (nav_index_module_default()).once, count.current > 1 && sticky && (nav_index_module_default()).active, 'for-pc')
    }), type === 1 && /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: (nav_index_module_default())["nav-mob"],
      ref: menuRef,
      children: menu.map(function (item, index) {
        return /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          onClick: function onClick() {
            return Goto(index, item.link);
          },
          className: classnames_default()((nav_index_module_default())["nav-mob-item"], index === current && (nav_index_module_default()).focus),
          children: item.name
        }, item.name);
      })
    }), type === 2 && /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: (nav_index_module_default())["nav-mob-2"],
      children: menu.map(function (item, index) {
        return /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          onClick: function onClick() {
            return Goto(index, item.link);
          },
          className: classnames_default()((nav_index_module_default())["nav-mob-item"], index === current && (nav_index_module_default()).focus),
          children: item.name
        }, item.name);
      })
    })]
  });
};

/* harmony default export */ var nav = (Nav);
;// CONCATENATED MODULE: ./src/components/product/relevance/wrapper/index.tsx









var menu1 = [{
  name: '智能硬件',
  link: '/hardware'
}, {
  name: '软件客户端',
  link: '/client'
}];
var menu2 = [{
  name: '一体化4K终端',
  link: '/hardware/fullSceneTerminal'
}, {
  name: '小鱼云镜',
  link: '/hardware/cloudMirrorSystem'
}, {
  name: '大型终端',
  link: '/hardware/flagshipTerminal'
}, {
  name: '中型终端',
  link: '/hardware/mediumTerminal'
}, {
  name: '中小型终端',
  link: '/hardware/integratedTerminal'
}, {
  name: '智能会议平板',
  link: '/hardware/meetingBoard'
}, {
  name: '电视墙服务器',
  link: '/hardware/TVwall'
}];
var menus = {
  '1': {
    name: '云视频会议',
    menu: menu1
  },
  '2': {
    name: '智能硬件',
    menu: menu2,
    type: 2
  }
};

var Wrapper = function Wrapper(_ref) {
  var title = _ref.title,
      current = _ref.current,
      children = _ref.children,
      _ref$menuIndex = _ref.menuIndex,
      menuIndex = _ref$menuIndex === void 0 ? '1' : _ref$menuIndex,
      customClass = _ref.customClass,
      pageKey = _ref.pageKey;
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(layout/* default */.Z, {
    layoutClass: (index_module_default()).layout,
    headerClass: (index_module_default()).header,
    children: [pageKey ? /*#__PURE__*/(0,jsx_runtime.jsx)(tdk/* default */.Z, {
      pageKey: pageKey
    }) : /*#__PURE__*/(0,jsx_runtime.jsx)((head_default()), {
      children: /*#__PURE__*/(0,jsx_runtime.jsxs)("title", {
        children: [menus[menuIndex].name, "-", title]
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)("section", {
      className: classnames_default()((index_module_default()).main, customClass),
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(nav, {
        menu: menus[menuIndex].menu,
        defaultIndex: current,
        type: menus[menuIndex].type || 1
      }), children]
    })]
  });
};

/* harmony default export */ var wrapper = (Wrapper);

/***/ }),

/***/ 42723:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ client; }
});

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(94184);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./src/components/product/specialty/index.module.scss
var index_module = __webpack_require__(77501);
var index_module_default = /*#__PURE__*/__webpack_require__.n(index_module);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./src/components/product/specialty/index.tsx






var Specialty = function Specialty(props) {
  var _props$type = props.type,
      type = _props$type === void 0 ? 1 : _props$type,
      title = props.title,
      desc = props.desc,
      image = props.image,
      _props$imgHost = props.imgHost,
      imgHost = _props$imgHost === void 0 ? '' : _props$imgHost,
      titleClass = props.titleClass,
      imgClass = props.imgClass,
      textClass = props.textClass,
      descClass = props.descClass,
      mDesc = props.mDesc;
  return /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
    className: (index_module_default()).specialty,
    children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: (index_module_default()).content,
      children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: classnames_default()((index_module_default())["specialty-text"], textClass, type !== 1 && (index_module_default()).order),
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: classnames_default()((index_module_default()).title, titleClass),
          children: title
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: classnames_default()((index_module_default()).desc, descClass, 'for-pc'),
          dangerouslySetInnerHTML: {
            __html: desc.replace(/\n/g, '<br>')
          }
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: classnames_default()((index_module_default()).desc, descClass, 'for-mobile'),
          dangerouslySetInnerHTML: {
            __html: (mDesc || desc).replace(/\n/g, '<br>')
          }
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("img", {
        className: classnames_default()((index_module_default()).fullImg, imgClass),
        src: imgHost + image,
        alt: ""
      })]
    })
  });
};

/* harmony default export */ var specialty = (Specialty);
// EXTERNAL MODULE: ./src/components/contact/index.tsx
var contact = __webpack_require__(53784);
// EXTERNAL MODULE: ./src/components/product/relevance/wrapper/index.tsx + 1 modules
var wrapper = __webpack_require__(58262);
// EXTERNAL MODULE: ./src/components/product/banner/multiple.tsx
var multiple = __webpack_require__(12221);
// EXTERNAL MODULE: ./src/utils/hooks/useResize.tsx
var useResize = __webpack_require__(94142);
// EXTERNAL MODULE: ./src/pages/client/index.module.scss
var client_index_module = __webpack_require__(94949);
var client_index_module_default = /*#__PURE__*/__webpack_require__.n(client_index_module);
;// CONCATENATED MODULE: ./src/pages/client/index.tsx
/*
 * 软件客户端
 */










var IMG_PREFIX = 'https://sdk-source.xylink.com/website/assets/client/';
var features = [{
  title: '一键组会，一秒入会',
  desc: '快速创建会议号，支持App消息、微信、短信、邮件全网渠\n道通知，简单极速入会',
  mDesc: '快速创建会议号，支持App消息、微信、短\n信、邮件全网渠道通知，简单极速入会'
}, {
  title: '预约会议，高效有序',
  desc: '支持预约周期会议，实时了解当前会议状态，让会议开启更有序',
  mDesc: '支持预约周期会议，实时了解当前会议状态，\n让会议开启更有序'
}, {
  title: '单位通讯录，全员覆盖',
  desc: '自主创建单位/企业，可邀请同事加入通讯录，支持分级分权'
}, {
  title: '小程序入会，轻便接入',
  desc: '支持通过小程序快速接入，会议开展更灵活'
}];
var functions = [{
  title: '高清体验，稳定流畅',
  desc: '全高清画质不花屏，畅享面对面交流效果\n声音高度还原，会议过程流畅不卡顿',
  img: ''
}, {
  title: '会议主持，专业易用',
  desc: '自定义显示布局，可进行点名、发送字幕、\n会议锁定、审批入会，会议更有序',
  img: ''
}, {
  title: '便捷共享，交互批注',
  desc: '一键共享，同步显示各类文档、图片、应用界面\n交互式批注可存档，内容水印更安全',
  img: ''
}, {
  title: '会议拆分，分组讨论',
  desc: '支持大会随时拆小会、小会一键合并大会\n方便发起分组讨论，提升沟通效果',
  img: ''
}, {
  title: '丰富应用，创新业务',
  desc: '智能美颜、虚拟背景、电子铭牌、会议纪要、\n同声传译、签到/答题/投票/即时消息',
  img: ''
}];
var scenes = [{
  title: '活动直播，实时互动',
  desc: '支持高清直播，一键对外分享\n具有直播公告、实时互动、发起投票等功能',
  img: ''
}, {
  title: '视频录制，随心剪辑',
  desc: '高清录制，支持自动或自定义布局\n在线视频剪辑，一键分享，范围可控',
  img: ''
}];

var Client = function Client() {
  var size = (0,useResize/* default */.Z)();
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(wrapper/* default */.Z, {
    title: "\u8F6F\u4EF6\u5BA2\u6237\u7AEF",
    pageKey: "productClient",
    current: 1,
    customClass: (client_index_module_default()).client,
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(multiple/* default */.Z, {
      mUrl: 'm/bg0.jpg',
      pcUrl: 'bg-img0.jpg',
      title: '软件客户端',
      desc: '覆盖全应用场景，结合智能硬件终端，高效构建“端云一体”的高品质视频会议\n电脑、平板、手机、小程序、网页端等全适配，纵享丰富音视频应用',
      mDesc: '覆盖全应用场景，结合智能硬件终端，高效构建\n“端云一体”的高品质视频会议\n电脑、平板、手机、小程序、网页端等全适配，\n纵享丰富音视频应用',
      imageHost: IMG_PREFIX,
      className: (client_index_module_default()).firstBanner
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: (client_index_module_default()).features,
      children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: (client_index_module_default()).header,
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: (client_index_module_default()).bigTitle,
          children: "\u79D2\u7EA7\u7EC4\u4F1A\uFF0C\u4E00\u952E\u5F00\u542F\u9AD8\u6548\u4F1A\u8BAE"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("img", {
          className: (client_index_module_default()).arrowImg,
          src: "".concat(IMG_PREFIX, "arrow-img0.png"),
          alt: "arrowImg"
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: (client_index_module_default()).content,
        children: features.map(function (item, index) {
          var _item$mDesc;

          return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
            className: (client_index_module_default()).feature,
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
              className: (client_index_module_default()).title,
              children: item.title
            }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
              className: (client_index_module_default()).desc,
              dangerouslySetInnerHTML: {
                __html: "".concat(size.width < 768 ? (_item$mDesc = item.mDesc) !== null && _item$mDesc !== void 0 ? _item$mDesc : item.desc : item.desc).replace(/\n/g, '<br/>')
              }
            }), /*#__PURE__*/(0,jsx_runtime.jsx)("img", {
              className: (client_index_module_default()).arrowImg,
              src: "".concat(IMG_PREFIX, "arrow-img1.png"),
              alt: "arrowImg"
            }), /*#__PURE__*/(0,jsx_runtime.jsx)("img", {
              className: (client_index_module_default()).bgImg,
              src: "".concat(IMG_PREFIX, "feature-img").concat(index, ".png"),
              alt: ""
            })]
          }, index);
        })
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: (client_index_module_default()).functions,
      children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: (client_index_module_default()).header,
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: (client_index_module_default()).bigTitle,
          children: "\u4E30\u5BCC\u529F\u80FD\uFF0C\u4F53\u9A8C\u9AD8\u54C1\u8D28\u4F1A\u8BAE"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("img", {
          className: (client_index_module_default()).arrowImg,
          src: "".concat(IMG_PREFIX, "arrow-img0.png"),
          alt: "arrowImg"
        })]
      }), functions.map(function (item, idx) {
        return /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: (client_index_module_default())["function"],
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(specialty, {
            title: item.title,
            desc: item.desc,
            image: "".concat(IMG_PREFIX, "function-img").concat(idx, ".png"),
            type: idx % 2 !== 0 ? 2 : 1,
            imgClass: classnames_default()((client_index_module_default()).img, idx === functions.length - 1 && (client_index_module_default()).lastImg),
            descClass: (client_index_module_default()).desc
          })
        }, idx);
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("img", {
        className: (client_index_module_default()).bigArrow0,
        src: "".concat(IMG_PREFIX, "bigArrow0.png"),
        alt: ""
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("img", {
        className: (client_index_module_default()).bigArrow1,
        src: "".concat(IMG_PREFIX, "bigArrow1.png"),
        alt: ""
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: (client_index_module_default()).scenes,
      children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: (client_index_module_default()).header,
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: (client_index_module_default()).bigTitle,
          children: "\u968F\u5FC3\u5206\u4EAB\uFF0C\u5168\u9762\u6EE1\u8DB3\u4E1A\u52A1\u9700\u6C42"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("img", {
          className: (client_index_module_default()).arrowImg,
          src: "".concat(IMG_PREFIX, "arrow-img2.png"),
          alt: "arrowImg"
        })]
      }), scenes.map(function (item, idx) {
        return /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: (client_index_module_default()).scene,
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(specialty, {
            title: item.title,
            desc: item.desc,
            image: "".concat(IMG_PREFIX, "share-img").concat(idx, ".png"),
            type: idx % 2 !== 0 ? 1 : 2,
            titleClass: (client_index_module_default()).title,
            descClass: (client_index_module_default()).desc,
            imgClass: (client_index_module_default()).img
          })
        }, idx);
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: (client_index_module_default()).lastBanner,
      style: {
        backgroundImage: "url(".concat(size.width < 768 ? "".concat(IMG_PREFIX, "m/bg1.jpg") : "".concat(IMG_PREFIX, "bg-img1.jpg"), ")")
      },
      children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: (client_index_module_default()).header,
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: (client_index_module_default()).bigTitle,
          children: "\u9002\u914D\u4FE1\u521B\uFF0C\u5B89\u5168\u62A4\u822A\u7EBF\u4E0A\u4F1A\u8BAE"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("img", {
          className: (client_index_module_default()).arrowImg,
          src: "".concat(IMG_PREFIX, "arrow-img2.png"),
          alt: "arrowImg"
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(specialty, {
        title: '小鱼易连信创云视频客户端',
        desc: '基于国产化平台打造，适配国产化CPU处理器操作系统的终端\n具备卓越的音视频效果，拥有丰富的会议协作能力\n全面保障线上会议和云端协同安全流畅',
        mDesc: '基于国产化平台打造\n适配国产化CPU处理器/操作系统的终端\n具备卓越的音视频效果，拥有丰富的会议协作能力\n全面保障线上会议和云端协同安全流畅',
        image: "".concat(IMG_PREFIX, "img.png"),
        textClass: (client_index_module_default()).text,
        titleClass: (client_index_module_default()).title,
        descClass: (client_index_module_default()).desc,
        imgClass: (client_index_module_default()).img
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(contact/* default */.Z, {
        className: (client_index_module_default()).contact,
        btnType: 'newBtn'
      })]
    })]
  });
};

/* harmony default export */ var client = (Client);

/***/ }),

/***/ 28937:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/client",
      function () {
        return __webpack_require__(42723);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 73649:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"border__px":"nav_border__px__LnplE","border__px-before":"nav_border__px-before__EVov9","border__px-before1":"nav_border__px-before1__2oD1e","border-children1":"nav_border-children1__g0F3X","border-children2":"nav_border-children2__DnnSf","for-mobile":"nav_for-mobile__ZciXU","for-pc":"nav_for-pc__z_KI0","nav__theme_parent":"nav_nav__theme_parent__T4U4O","logo":"nav_logo__WR8zR","show":"nav_show__4YtHP","nav-pc":"nav_nav-pc__bFsJ0","nav-pc-item":"nav_nav-pc-item__kYYYW","focus":"nav_focus__ByYUr","once":"nav_once__aksOZ","sticky":"nav_sticky__l7SSZ","transition":"nav_transition__B1wHH","active":"nav_active__1D68f","nav-mob":"nav_nav-mob__FuCYJ","nav-mob-2":"nav_nav-mob-2__6Mv2f","nav-mob-item":"nav_nav-mob-item__6k_Rb"};

/***/ }),

/***/ 89262:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"border__px":"wrapper_border__px__F6VvU","border__px-before":"wrapper_border__px-before__Mxpn1","border__px-before1":"wrapper_border__px-before1__EFvO6","border-children1":"wrapper_border-children1__KmKjR","border-children2":"wrapper_border-children2__7Jboy","for-mobile":"wrapper_for-mobile__2kveH","for-pc":"wrapper_for-pc__yuzrw","layout":"wrapper_layout__j4SAy","header":"wrapper_header__l9dYm"};

/***/ }),

/***/ 77501:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"border__px":"specialty_border__px__VEbLa","border__px-before":"specialty_border__px-before__IA7RW","border__px-before1":"specialty_border__px-before1__M1F92","border-children1":"specialty_border-children1__2jRUt","border-children2":"specialty_border-children2___cfLn","for-mobile":"specialty_for-mobile__1765e","for-pc":"specialty_for-pc__SZit3","specialty":"specialty_specialty__4E0lK","content":"specialty_content__VRYaX","specialty-text":"specialty_specialty-text__4ar3w","order":"specialty_order__Q3kD7","title":"specialty_title__f2iMI","desc":"specialty_desc__1aEKG","fullImg":"specialty_fullImg__QIfOR","specialty-img":"specialty_specialty-img__m_3kz"};

/***/ }),

/***/ 94949:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"border__px":"client_border__px__y4Ddk","border__px-before":"client_border__px-before__MWbq4","border__px-before1":"client_border__px-before1__3evI3","border-children1":"client_border-children1__emRQ8","border-children2":"client_border-children2__vmydc","for-mobile":"client_for-mobile__eoPGo","for-pc":"client_for-pc__jxnj8","client":"client_client__aNKzY","lastBanner":"client_lastBanner__1j2eP","header":"client_header__tVQNB","bigTitle":"client_bigTitle__YcqUh","scenes":"client_scenes__Ppkxt","functions":"client_functions__rNL11","features":"client_features__1lMA1","arrowImg":"client_arrowImg__NgR_a","firstBanner":"client_firstBanner__qKKaL","content":"client_content__ChvWO","feature":"client_feature__vesy0","title":"client_title__U0DQ5","desc":"client_desc___yeqs","bgImg":"client_bgImg__gWT_W","function":"client_function__a1S4f","img":"client_img__sV_ie","lastImg":"client_lastImg__p6ceE","bigArrow0":"client_bigArrow0__YeV0x","bigArrow1":"client_bigArrow1__QRMTM","scene":"client_scene__3ZhUL","text":"client_text__Hx05S","contact":"client_contact__t4LiY"};

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [9243,9774,2888,179], function() { return __webpack_exec__(28937); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);